import { useLocation, useNavigate } from "react-router";

import {
  getPatchFallbackRoute,
  isPatchReport,
} from "pages/patchMonitoring/patchMonitoring.config";
import { getRoleInitialRoute } from "utils/routes.util";

/**
 * Leaves pages that display only a modal (e.g., a report or patient profile on its own URL).
 * Closes the tab if it was opened specifically for this page; otherwise, navigates back
 * one page or falls back to the user's initial page, rather than the saved previous path,
 * which points to this page.
 * Pass { keepTab: true } to prevent the tab from closing, e.g., while an Undo toast
 * must remain accessible.
 * Pass { report } so a patch report falls back to its Patch Monitoring tab instead of the
 * user's initial page; the navigate(-1) branch already returns to the tab it came from.
 */
const useCloseModalPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return ({ keepTab = false, report } = {}) => {
    if (!keepTab && window.history.length <= 1) {
      window.close();

      if (window.closed) return;
    }

    if (location.key !== "default") {
      navigate(-1);
      return;
    }

    const patchRoute = isPatchReport(report)
      ? getPatchFallbackRoute(localStorage.getItem("userRole"))
      : null;

    navigate(patchRoute || getRoleInitialRoute(), { replace: true });
  };
};

export default useCloseModalPage;
